module.exports = __webpack_public_path__ + "static/media/zappertak-4.5fee6f7d.jpg";